<!--c2c交易-->
<template>
	<div class="page-body center-wrap">
		<div class="top-card">
			<div class="left-con txt-ali-cen txt-16">
				<span class="c2c-text">C2C 交易</span>
				<span class="line"></span>
				<div class="item">
					<div>0.00</div>
					<div><span>法幣餘額</span>HKD</div>
				</div>
				<span class="line"></span>
				<div class="item">
					<div class="">27,280.54</div>
					<div class=""><span>餘額(USDT)</span></div>
				</div>
				<span class="line"></span>
				<div class="item">
					<div>0</div>
					<div><span>掛單中(USDT)</span></div>
				</div>
			</div>
			<div class="right-con">
				<div class="operate-btn">
					<img src="@/assets/img-pc/53.9e96b1da.svg" alt="">
					<div class="name">我要買</div>
				</div>
				<div class="operate-btn active">
					<img src="@/assets/img-pc/54.cc1b7bdf.svg" alt="">
					<div class="name">我要賣</div>
				</div>
				<div class="operate-btn white ">
					<div class="name">訂單</div>
				</div>
			</div>
		</div>

		<div class="tab-group">
			<span class="tab active">賣出訂單</span>
			<span class="tab">賣給商家</span>
		</div>

		<div class="list-div">
			<div class="list">
				<div class="card" v-for="i in 5" :key="i">
					<div class="top">
						<img src="@/assets/img-pc/55.1e652e0f.svg" alt="" class="sell-logo">
						<span>出售KRW</span>
						<button class="btn2">已完成</button>
					</div>
					<p class="row">
						<span>商家</span>
						<span>test@gmail.com</span>
					</p>
					<p class="row">
						<span>賣出</span>
						<span>7,550,000 KRW</span>
					</p>
					<p class="row">
						<span>價格</span>
						<span>1,510 USDT</span>
					</p>
					<p class="row">
						<span>金額</span>
						<span>5,000 USDT</span>
					</p>
					<p class="row">
						<span>日期</span>
						<span>2025/03/29 17:36:12</span>
					</p>
				</div>
			</div>
			<div class="no-data">沒有更多了</div>
		</div>
	</div>
</template>
<script>
	export default {
		components: {},
		data() {
			return {
				form: {}
			};
		},
		mounted() {

		},
		beforeUnmount() {},
		methods: {

		},
	};
</script>
<style lang="scss" scoped>
	.list-div {

		.list {
			display: flex;
			flex-wrap: wrap;
			padding-top: 30px;

			.card {
				width: 31%;
				margin: 0 2.33% 30px 0;
				padding: 20px;
				border-radius: 15px;
				border: 1px solid #3c3e53;
				color: #fff;
				background: #0b0b0d;
				display: flex;
				flex-wrap: nowrap;
				flex-direction: column;
				align-items: normal;
				justify-content: normal;

				.row {
					margin: 0;
					line-height: 14px;
					margin-bottom: 10px;
					display: flex;
					align-items: center;
					justify-content: space-between;

					span {
						&:nth-of-type(2) {
							// flex: 1;
						}

						&:first-of-type {
							color: #adadad;
						}
					}
				}

				.top {
					position: relative;
					display: flex;
					align-items: center;
					height: 41px;
					margin-bottom: 20px;

					.btn2 {
						background: linear-gradient(270deg, #9dfc7b, #62f94e);
						height: 22px;
						line-height: 22px;
						padding: 0 5px;
						color: #000;
						border-radius: 8px;
						font-size: 12px;
						border-width: 0;
					}

					span {
						font-size: 14px;
						line-height: 14px;
						margin-right: auto;
					}

					.sell-logo {
						width: 30px;
						height: 30px;
						margin-right: 10px;
					}
				}
			}
		}

		.no-data {
			text-align: center;
			font-size: 14px;
			color: #888;
			margin: 30px;
		}
	}

	.tab-group {
		margin: 20px 0;

		.tab {
			height: 46px;
			margin-right: 14px;
			border-radius: 100px;
			padding: 0 24px;
			font-size: 18px;
			line-height: 20px;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
			color: #fff;

			&.active {
				color: #000;
				background: linear-gradient(90deg, #00e3ff, #089);
			}
		}
	}

	.top-card {
		width: 100%;
		height: 72px;
		margin: 0;
		border: 1px solid #252731;
		box-shadow: 0 0 10px rgba(0, 0, 0, .10196078431372549);
		padding: 0 20px;
		border-radius: 999px;
		display: flex;
		align-items: center;
		color: #fff;

		.right-con {
			margin-top: 10px;
			display: flex;
			justify-content: space-between;

			.operate-btn {
				min-width: 80px;
				height: 40px;
				line-height: 15px;
				display: flex;
				align-items: center;
				justify-content: center;
				border-radius: 99px;
				border: 1px solid #84849f;
				background: #0f0f16;
				font-size: 16px;
				text-align: center;
				cursor: pointer;
				margin-left: 20px;
				padding: 0 26px;

				&.active {
					background: #00f0ff;
					color: #000;
					border: 0;
				}

				&.white {
					background: #fff;
					color: #000;
					border: 0;
				}

				img {
					width: 24px;
					height: 24px;
				}

				.name {
					margin-left: 5px;
				}
			}
		}

		.left-con {
			display: flex;
			align-items: center;
			text-align: center;

			.c2c-text {
				color: #00f0ff;
				font-size: 24px;
				line-height: 40px;
			}

			span {
				color: #848e9c;
			}
		}

		.line {
			width: 2px;
			height: 14px;
			margin: 0 30px;
			background-color: #3c3e53;
		}
	}
</style>